import { defineMessages } from 'react-intl';

export default defineMessages({
    naFireDamage: {
        id: 'fnol.common.views.details.Was there damage due to a Fire?',
        defaultMessage: 'Was there damage due to a Fire?'
    },
    naWaterDamage: {
        id: 'fnol.common.views.details.Was there damage due to water?',
        defaultMessage: 'Was there damage due to water?'
    },
    naDwellingDamage: {
        id: 'fnol.common.views.details.Is there damage to dwelling?',
        defaultMessage: 'Is there damage to dwelling?'
    },
    incidentDetails: {
        id: 'fnol.non-auto.views.Incident Details',
        defaultMessage: 'Incident Details'
    },
    lossCause: {
        id: 'fnol.non-auto.views.Loss Cause',
        defaultMessage: 'Loss Cause'
    },
    propertyDamage: {
        id: 'fnol.common.views.details.Is there damage to personal property?',
        defaultMessage: 'Is there damage to personal property?'
    },
    otherStructuresDamage: {
        id: 'fnol.common.views.details.Is there damage to any other structures of your property?',
        defaultMessage: 'Is there damage to any other structures of your property?'
    },
    additionalExpenses: {
        id: 'fnol.common.views.details.Any additional expenses required?',
        defaultMessage: 'Any additional expenses required?'
    },
    expensesReason: {
        id: 'fnol.common.views.details.Please describe the reason',
        defaultMessage: 'Please describe the reason'
    },
    hoDetails: {
        id: 'fnol.common.views.details.Details',
        defaultMessage: 'Details'
    },
    otherCreateDraftErrorTitle: {
        id: 'fnol.nonauto.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    otherCreateDraftErrorMessage: {
        id: 'fnol.nonauto.config.FlowConfig.An error occurred attempting to create claim.',
        defaultMessage: 'An error occurred attempting to create claim.'
    },
    paymentPreference: {
        id: 'fnol.wizard.step.nonAuto.Payment Preference',
        defaultMessage: 'Payment Preference'
    }
});
